import { render, staticRenderFns } from "./AlertsNotifications.vue?vue&type=template&id=9c2f6f00&scoped=true"
import script from "./AlertsNotifications.vue?vue&type=script&lang=js"
export * from "./AlertsNotifications.vue?vue&type=script&lang=js"
import style0 from "./AlertsNotifications.vue?vue&type=style&index=0&id=9c2f6f00&prod&scoped=true&lang=scss"
import style1 from "./AlertsNotifications.vue?vue&type=style&index=1&id=9c2f6f00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c2f6f00",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCheckbox,VIcon,VRow})
